import React, { useEffect, useState } from "react";
import { Box, Typography, Chip, CircularProgress } from "@mui/material";
import { useLocation } from "react-router-dom";
import EventsTable from "containers/pages/CANprospect/Events/EventsTable";
import getSingleProspect from "api/canprospect/getSingleProspect";

function Events() {
  const [companyName, setCompanyName] = useState<string | null>(null); 
  const [firstName, setFirstName] = useState<string | null>(null);
  const [lastName, setLastName] = useState<string | null>(null);
  const [prospectStatusId, setProspectStatusId] = useState<number | null>(null); 
  const [loading, setLoading] = useState(true); 

  // Extract the query string from the URL
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const prospectId = queryParams.get("prospect");
  const prospectIdInt = prospectId ? parseInt(prospectId, 10) : null;

  useEffect(() => {
    const fetchProspect = async () => {
      if (prospectIdInt === null || isNaN(prospectIdInt)) {
        console.error("Invalid prospect ID:", prospectId);
        setLoading(false);
        return;
      }

      try {
        const prospect = await getSingleProspect(prospectIdInt);
        if (prospect) {
          setCompanyName(prospect.CompanyName || "Unknown");
          setFirstName(prospect.FirstName || "");
          setLastName(prospect.LastName || "");
          setProspectStatusId(prospect.ProspectStatusId || null); 
        } else {
          setCompanyName("Unknown");
          setFirstName("");
          setLastName("");
          setProspectStatusId(null);
        }
      } catch (error) {
        console.error("Error fetching prospect:", error);
        setCompanyName("Error");
        setFirstName("");
        setLastName("");
        setProspectStatusId(null);
      } finally {
        setLoading(false);
      }
    };

    fetchProspect();
  }, [prospectIdInt, prospectId]);

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "90%",
        margin: "auto",
      }}
    >
      <Typography variant="h4" style={{ marginBottom: "0.5rem" }}>
        Prospect Events
      </Typography>

      <Box style={{ marginBottom: "1rem", display: "flex", alignItems: "center" }}>
        {loading ? (
          <Chip
            label={<CircularProgress size={20} color="inherit" />}
            variant="filled"
            style={{ fontSize: "1rem", marginBottom: "1rem" }}
          />
        ) : (
          <Chip
            label={`${firstName} ${lastName} | ${companyName}`}
            variant="filled"
            style={{ fontSize: "1rem", marginBottom: "1rem" }}
          />
        )}
      </Box>

      <EventsTable
        prospectId={prospectIdInt}
        prospectStatusId={prospectStatusId} 
      />
    </Box>
  );
}

export default Events;
